import moment from 'moment';

import {IContextLookupValue} from 'modules/context/context-types';
import {DATE, DATE_DMY} from 'shared/constants/date-format';

export const extractFilterValuesFromRequestData = (data?: {[index: string]: any}, prefillDates = true) => {
    const {
        document_id: aisDocId,
        cparty_inn: cpartyInn,
        cparty_kpp: cpartyKpp,
        document_code: docCode,
        cparty_country_code: cpartyCountryCode,
        cparty_foreign_reg_number: cpartyForeignRegNum,
        docDate,
        dateFrom,
        dateTo,
        ...rest
    } = data ?? {};

    const dateFromFormatted = (() => {
      if (dateFrom) return moment(dateFrom, DATE_DMY).format(DATE);

      if (!prefillDates) return undefined;

      return moment(new Date()).subtract(3, 'years').format(DATE);
    })();

    const dateToFormatted = (() => {
      if (dateTo) return moment(dateTo, DATE_DMY).format(DATE);

      if (!prefillDates) return undefined;

      return moment().endOf('year').format(DATE);
    })();

    const docDateFormatted = docDate ? moment(docDate, DATE_DMY).format(DATE) : undefined;

    return {
        dateFrom: dateFromFormatted,
        dateTo: dateToFormatted,
        docDate: docDateFormatted,
        aisDocId,
        cpartyInn,
        cpartyKpp,
        docCode,
        cpartyCountryCode,
        cpartyForeignRegNum,
        ...rest,
    };
};

export const SPVDOCOptionsLabelFormatter = (
    label: string,
    {lookupCode, meaning}: Pick<IContextLookupValue, 'lookupCode' | 'meaning'>,
) => `${meaning} (${lookupCode})`;
